// Product Tabs - Scroll Navigation Arrows

(function() {
  'use strict';

  function initTabArrows() {
    const arrowContainers = document.querySelectorAll('.tab-nav-arrows');
    
    arrowContainers.forEach(arrowContainer => {
      const tabIndex = arrowContainer.getAttribute('data-tab-index');
      
      // Find parent section first
      const parentSection = arrowContainer.closest('.section--product-tabs') || arrowContainer.closest('[data-section-type="product-tabs"]');
      
      // Search within parent section only
      let scrollContainer = null;
      if (parentSection) {
        scrollContainer = parentSection.querySelector(`.tab-scroll-container[data-tab-index="${tabIndex}"] .swipe-desktop__inner`);
        
        if (!scrollContainer) {
          scrollContainer = parentSection.querySelector(`.tab-scroll-container[data-tab-index="${tabIndex}"] .products-list`);
        }
      }
      
      if (!scrollContainer) {
        console.warn('Scroll container not found for tab:', tabIndex, 'in section:', parentSection);
        return;
      }
      
      console.log('Scroll container found:', scrollContainer);
      
      const prevBtn = arrowContainer.querySelector('.tab-arrow-prev');
      const nextBtn = arrowContainer.querySelector('.tab-arrow-next');
      
      if (!prevBtn || !nextBtn) return;
      
      // Scroll function
      function scrollTab(direction) {
        const scrollAmount = scrollContainer.offsetWidth * 0.8;
        const currentScroll = scrollContainer.scrollLeft;
        
        if (direction === 'prev') {
          scrollContainer.scrollTo({
            left: currentScroll - scrollAmount,
            behavior: 'smooth'
          });
        } else {
          scrollContainer.scrollTo({
            left: currentScroll + scrollAmount,
            behavior: 'smooth'
          });
        }
      }
      
      // Update button states
      function updateButtons() {
        const maxScroll = scrollContainer.scrollWidth - scrollContainer.offsetWidth;
        
        // Prev button
        if (scrollContainer.scrollLeft <= 10) {
          prevBtn.disabled = true;
        } else {
          prevBtn.disabled = false;
        }
        
        // Next button
        if (scrollContainer.scrollLeft >= maxScroll - 10) {
          nextBtn.disabled = true;
        } else {
          nextBtn.disabled = false;
        }
      }
      
      // Event listeners
      prevBtn.addEventListener('click', () => scrollTab('prev'));
      nextBtn.addEventListener('click', () => scrollTab('next'));
      
      scrollContainer.addEventListener('scroll', updateButtons, { passive: true });
      
      // Reset scroll position to start
      scrollContainer.scrollLeft = 0;
      
      // Initial state - with delay to ensure proper rendering
      setTimeout(() => {
        scrollContainer.scrollLeft = 0; // Force to start again
        updateButtons();
      }, 100);
      
      // Also update on resize
      window.addEventListener('resize', () => {
        updateButtons();
      }, { passive: true });
    });
  }

  // Mobile pagination dots
  function initMobileDots() {
    const dotContainers = document.querySelectorAll('.tab-pagination-dots');
    
    console.log('Found dot containers:', dotContainers.length);
    
    dotContainers.forEach(dotContainer => {
      const tabIndex = dotContainer.getAttribute('data-tab-index');
      
      // Find parent section first
      const parentSection = dotContainer.closest('.section--product-tabs') || dotContainer.closest('[data-section-type="product-tabs"]');
      
      // Scroll container - grid-list elementi tap (parent section içində)
      let scrollContainer = null;
      if (parentSection) {
        scrollContainer = parentSection.querySelector(`[data-tab-index="${tabIndex}"].tab-scroll-container`);
        
        // Əgər grid-list özü scroll edirsə
        if (scrollContainer && scrollContainer.tagName === 'GRID-LIST') {
          // grid-list özü scroll container-dir
        } else if (scrollContainer) {
          // grid-list içində axtaraq
          const gridList = scrollContainer.querySelector('grid-list');
          if (gridList) {
            scrollContainer = gridList;
          }
        }
      }
      
      console.log('Mobile scroll container for tab', tabIndex, ':', scrollContainer);
      console.log('Scroll container classes:', scrollContainer?.className);
      
      if (!scrollContainer) return;
      
      const items = scrollContainer.querySelectorAll('.f-column');
      const itemCount = items.length;
      
      if (itemCount <= 1) return;
      
      // Səhifələmə - mobil 2 məhsul 1 səhifə
      const itemsPerPage = 2;
      const pageCount = Math.ceil(itemCount / itemsPerPage);
      
      // Dynamic bullets - maksimum göstəriləcək dot sayı
      const maxVisibleDots = 7;
      const useDynamicBullets = pageCount > maxVisibleDots;
      
      console.log('Items:', itemCount, 'Pages:', pageCount, 'Dynamic:', useDynamicBullets);
      
      // Scroll tracking - səhifə əsaslı
      function updateActiveDot() {
        const scrollLeft = scrollContainer.scrollLeft;
        const containerWidth = scrollContainer.offsetWidth;
        const totalWidth = scrollContainer.scrollWidth;
        const maxScroll = totalWidth - containerWidth;
        
        // Hər səhifənin genişliyi (2 məhsul)
        const itemWidth = items[0]?.offsetWidth || 0;
        const gap = 8;
        const pageWidth = (itemWidth * itemsPerPage) + (gap * (itemsPerPage - 1));
        
        // Aktiv səhifə hesabla
        let activePage = Math.round(scrollLeft / pageWidth);
        
        // Əgər sonda isə - son səhifə aktiv olsun
        if (scrollLeft >= maxScroll - 20) {
          activePage = pageCount - 1;
        }
        
        // Range check
        if (activePage >= pageCount) {
          activePage = pageCount - 1;
        }
        if (activePage < 0) {
          activePage = 0;
        }
        
        console.log('ScrollLeft:', scrollLeft, 'PageWidth:', pageWidth, 'Active page:', activePage);
        
        // Dynamic bullets - dots-u yenilə
        if (useDynamicBullets) {
          const halfVisible = Math.floor(maxVisibleDots / 2);
          let startPage = Math.max(0, activePage - halfVisible);
          let endPage = Math.min(pageCount, startPage + maxVisibleDots);
          
          if (endPage - startPage < maxVisibleDots) {
            startPage = Math.max(0, endPage - maxVisibleDots);
          }
          
          // Aktiv dot mövqeyini hesabla
          let activeDotPosition;
          if (activePage < halfVisible) {
            activeDotPosition = activePage;
          } else if (activePage >= pageCount - halfVisible) {
            activeDotPosition = maxVisibleDots - (pageCount - activePage);
          } else {
            activeDotPosition = halfVisible;
          }
          
          // Update dots - data-page və active class
          const allDots = dotContainer.querySelectorAll('.tab-pagination-dot');
          allDots.forEach((dot, i) => {
            const dotPage = startPage + i;
            dot.setAttribute('data-page', dotPage);
            dot.setAttribute('aria-label', `Səhifə ${dotPage + 1}`);
            
            // Remove active və transform
            dot.classList.remove('active');
            dot.style.transform = '';
            dot.style.width = '';
            dot.style.height = '';
            dot.style.opacity = '';
            
            if (i === activeDotPosition) {
              // Aktiv dot - BÖYÜK
              dot.classList.add('active');
              dot.style.width = '8px';
              dot.style.height = '8px';
              dot.style.opacity = '1';
            } else {
              // Side dots - ölçü və opacity
              const distance = Math.abs(i - activeDotPosition);
              if (distance === 1) {
                // Qonşu dots - orta
                dot.style.width = '6px';
                dot.style.height = '6px';
                dot.style.opacity = '0.8';
              } else if (distance === 2) {
                // 2 məsafə - kiçik
                dot.style.width = '5px';
                dot.style.height = '5px';
                dot.style.opacity = '0.6';
              } else {
                // Uzaq dots - çox kiçik
                dot.style.width = '4px';
                dot.style.height = '4px';
                dot.style.opacity = '0.4';
              }
            }
          });
        } else {
          // Normal - sadəcə active class dəyiş
          const allDots = dotContainer.querySelectorAll('.tab-pagination-dot');
          allDots.forEach((dot, i) => {
            if (i === activePage) {
              dot.classList.add('active');
            } else {
              dot.classList.remove('active');
            }
          });
        }
      }
      
      // Create dots - MAKSIMUM 7 DOT
      dotContainer.innerHTML = '';
      
      // Dynamic bullets üçün dot sayı
      const visibleDots = useDynamicBullets ? maxVisibleDots : pageCount;
      
      for (let i = 0; i < visibleDots; i++) {
        const dot = document.createElement('button');
        dot.className = 'tab-pagination-dot' + (i === 0 ? ' active' : '');
        dot.setAttribute('data-page', i);
        dot.setAttribute('aria-label', `Səhifə ${i + 1}`);
        dotContainer.appendChild(dot);
        
        // Click handler - data-page atributundan oxu
        dot.addEventListener('click', () => {
          const targetPage = parseInt(dot.getAttribute('data-page')) || i;
          const firstItemIndex = targetPage * itemsPerPage;
          const firstItem = items[firstItemIndex];
          if (firstItem) {
            firstItem.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
          }
        });
      }
      
      // İLK YÜKLƏMƏDƏ updateActiveDot çağır
      updateActiveDot();
      
      console.log('Adding scroll listener to:', scrollContainer, 'Tag:', scrollContainer.tagName);
      
      // Test scroll
      scrollContainer.addEventListener('scroll', () => {
        console.log('✅ SCROLL EVENT! scrollLeft:', scrollContainer.scrollLeft);
        updateActiveDot();
      }, { passive: true });
      
      // Touch events əlavə (əgər scroll event işləmirsə)
      scrollContainer.addEventListener('touchmove', () => {
        console.log('📱 TOUCH MOVE!');
        setTimeout(updateActiveDot, 100);
      }, { passive: true });
      
      // Reset scroll position to start
      scrollContainer.scrollLeft = 0;
      
      // Initial - başlanğıcda 0 olsun
      setTimeout(() => {
        scrollContainer.scrollLeft = 0; // Force to start
        updateActiveDot();
      }, 500);
    });
  }

  // Init
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initTabArrows();
      initMobileDots();
    });
  } else {
    initTabArrows();
    initMobileDots();
  }

  // Shopify events
  document.addEventListener('shopify:section:load', () => {
    initTabArrows();
    initMobileDots();
  });
})();

